export const SIDEBAR_WIDTH = '286px';
export const SIDEBAR_MOBILE_WIDTH = '85px';

export const MODAL_WIDTH = '460px';